import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=8ae22134&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=8ae22134&prod&lang=scss&scoped=true"
import style1 from "./DetailList.vue?vue&type=style&index=1&id=8ae22134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae22134",
  null
  
)

export default component.exports